<template>
  <div v-if="hasError" class="app-alert-error app-system-alert" id="payError" role="alert" ref="payError">
    <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <p ref="alertMessageRef" tabindex="-1">{{ message }}</p>
  </div>
</template>


<script setup>
import { computed, onUpdated, ref } from 'vue';
import _ from 'underscore';
import MESSAGES from '@/assets/_systemFeedback';

// Define props
const props = defineProps({
  hasError: {
    type: Boolean,
    required: false,
    default: false,
  },
  errorMessage: {
    type: String,
    required: false,
    default: '',
  },
});

// Template ref 
const alertMessageRef = ref(null);

// Computed properties
const catchAllError = computed(() => {
  const err = _.find(MESSAGES, item => item.code === 35);
  return err ? err.message : 'Your payment was not successful! Please try again.';
});

const message = computed(() => {
  return (props.errorMessage.length > 0) ? props.errorMessage : catchAllError.value;
});

// Lifecycle hook
onUpdated(() => {
  if (alertMessageRef.value) {
    alertMessageRef.value.focus();
  }
});
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/system-alert";
</style>
